import * as types from '../../types';

export interface InAppSheetLinePrice {
  priceInCents: number;
  /** the catalog price to strike through when the server priced the collar lower */
  listPriceInCents?: number;
}

/**
 * The price shown on one sheet row. A hardware-first collar takes the server's discounted unit price
 * with its list price for the strikethrough; anything else is the catalog price, plus the bundled
 * membership's when there is one.
 */
export default function inAppSheetLinePrice({
  productPriceInCents,
  subProductPriceInCents,
  hardwareDiscount,
}: {
  productPriceInCents: number;
  subProductPriceInCents?: number;
  hardwareDiscount?: types.HardwareDiscountPreview;
}): InAppSheetLinePrice {
  if (hardwareDiscount) {
    return {
      priceInCents: hardwareDiscount.discountedPriceInCents,
      listPriceInCents:
        hardwareDiscount.listPriceInCents > hardwareDiscount.discountedPriceInCents
          ? hardwareDiscount.listPriceInCents
          : undefined,
    };
  }
  return { priceInCents: productPriceInCents + (subProductPriceInCents ?? 0) };
}
